
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Country } from '../../lib/models/Country'
import { User } from '../../lib/models/User'
import { Http } from '../../lib/utils/Http'
import BacButton from '../BacButton.vue'
import BacInput from '../BacInput.vue'
import BacAlert from '../BacAlert.vue'

@Component({
  components: {
    BacButton,
    BacInput,
    BacAlert
  }
})
export default class RallyRegisterAddress extends Vue {
  @Prop({ required: true }) user!: User;

  mode = 'show';

  countries: Country[] = [];

  mounted () {
    this.onUserChange()
    this.loadCountries()
  }

  @Watch('user')
  onUserChange () {
    this.mode = this.user.hasValidAddress ? 'show' : 'edit'
    if (this.countries && this.countries.length) {
      const selectedCountry = this.countries.find((country) => {
        return country.id === this.user.countryId
      })
      if (selectedCountry) {
        this.user.country = selectedCountry.name
      }
    }
  }

  async loadCountries () {
    let countryData = null
    const countriesFromLocalStorage = localStorage.getItem('countries')
    const countriesJson = countriesFromLocalStorage
      ? JSON.parse(countriesFromLocalStorage)
      : null
    if (!countriesJson || Date.now() - 3600000 >= countriesJson.time) {
      countryData = await (await Http.request('/api/country')).json()
      localStorage.setItem(
        'countries',
        JSON.stringify({ time: Date.now(), countries: countryData })
      )
    } else {
      countryData = countriesJson.countries
    }

    countryData.forEach((country: any) => {
      const newCountry = new Country()
      newCountry.id = country.country_id
      newCountry.name = country.name
      newCountry.isoCode2 = country.iso_code_2
      this.countries.push(newCountry)
    })

    if ((this.user as any).countryId) {
      const selectedCountry = this.countries.find((country) => {
        return country.id === (this.user as any).countryId
      })
      if (selectedCountry) {
        this.user.country = selectedCountry.isoCode2
      }
    }
  }
}
